"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useStyleSet;

var _useWebChatUIContext = _interopRequireDefault(require("./internal/useWebChatUIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useStyleSet() {
  return [(0, _useWebChatUIContext.default)().styleSet];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VTdHlsZVNldCIsInVzZVdlYkNoYXRVSUNvbnRleHQiLCJzdHlsZVNldCJdLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2hvb2tzL3VzZVN0eWxlU2V0LnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB1c2VXZWJDaGF0VUlDb250ZXh0IGZyb20gJy4vaW50ZXJuYWwvdXNlV2ViQ2hhdFVJQ29udGV4dCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZVN0eWxlU2V0KCk6IFthbnldIHtcbiAgcmV0dXJuIFt1c2VXZWJDaGF0VUlDb250ZXh0KCkuc3R5bGVTZXRdO1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7QUFFZSxTQUFTQSxXQUFULEdBQThCO0VBQzNDLE9BQU8sQ0FBQyxJQUFBQyw0QkFBQSxJQUFzQkMsUUFBdkIsQ0FBUDtBQUNEIn0=